import { memoCoursesType, priceType } from "@/interFace/courses/types";
import { GetCurrencySymbolFromCode } from "@/lib/Pricing";

export interface TableSquarePriceOption {
  priceId: string;
  currencyCode: string;
  amount: number;
}

export interface TableSquarePricingResponse {
  countryCode: string;
  currencyCode: string;
  isFallbackCurrency: boolean;
  language: string;
  isPurchasable: boolean;
  unavailableReason?: string | null;
  selectedPrice?: TableSquarePriceOption | null;
  prices: TableSquarePriceOption[];
}

const getCurrencyTypeFromCode = (currencyCode: string): number => {
  switch (currencyCode.toUpperCase()) {
    case "EUR":
      return 0;
    case "CHF":
      return 1;
    case "USD":
    case "CAD":
      return 2;
    case "GBP":
    default:
      return 3;
  }
};

export function mapTableSquareCoursePricing(
  course: memoCoursesType,
  tableSquarePricing: TableSquarePricingResponse | null
): memoCoursesType {
  if (course.courseTypeId !== 0) {
    return course;
  }

  const selectedPrice = tableSquarePricing?.selectedPrice;
  if (!selectedPrice) {
    return {
      ...course,
      prices: undefined,
      localPrices: undefined,
      isPurchasable: false,
      unavailableReason: tableSquarePricing?.unavailableReason || "This course is currently unavailable in your region.",
    };
  }

  const stripePrice: priceType = {
    currency: getCurrencyTypeFromCode(selectedPrice.currencyCode),
    price: selectedPrice.amount,
    oldPrice: 0,
    currencySymbol: GetCurrencySymbolFromCode(selectedPrice.currencyCode),
    discountPercentage: 0,
    isoCode: tableSquarePricing.currencyCode === "EUR" ? "EU" : "GB",
  };

  return {
    ...course,
    prices: [stripePrice],
    localPrices: [stripePrice],
    isPurchasable: true,
    unavailableReason: undefined,
  };
}